import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ProjectList from "./ProjectsList";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import ProjectsFilter from "./ProjectsFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import Notification from "../../elements/notification/Notification";
import ProjectsForm from "./ProjectsForm";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import { removeTransferFromCollection } from "../../../utils/collections";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledProjectsWrapper } from "../styledProjects";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const ProjectsContainer = () => {
  const { t } = useTranslation("projectsPage");
  const [projects, setProjects] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "name": checkFilterItem(history, "name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchProjects = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/projects" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProjects(removeTransferFromCollection(response.data["hydra:member"]));
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchProjects();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledProjectsWrapper>
          <div className="project-head">
            <ProjectsFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <ProjectsForm
              fetchProjects={fetchProjects}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ProjectList projects={projects} />
          {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
        </StyledProjectsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default ProjectsContainer;
